module.exports = __webpack_public_path__ + "images/stickers/pete-ghost.a3b37adb0c5217d27eef.png";